const $ = window.$;

$(function () {
  $('.js-check-agree').on('change', function(){
    $('.js-check-submit').prop('disabled', !$(this).prop('checked'));
  }).trigger('change');
});
